import { getMidpoint } from '~/core/helpers';
import { DrawingShape } from '~/core/models';

type TopMostEdge = {
  minY: number;
  index: number;
};

/**
 * returns the index of the "TopMost" drawingEdge with the "highest" (visually) midPoint.y value
 * @param shape
 */
export const getLetterStartFromDrawingEdges = (shape: DrawingShape): number => {
  const corners = Object.values(shape.cornerMap);
  const topEdge = shape.drawingEdges.reduce(
    (result, edge, edgeIndex) => {
      const startPt = corners.find(
        (corner) => corner.id === edge.startCornerId
      );
      const endPt = corners.find((corner) => corner.id === edge.endCornerId);

      if (!startPt || !endPt) {
        return result;
      }

      const midPt = getMidpoint(startPt.coords, endPt.coords);

      return midPt.y < result.minY
        ? ({ minY: midPt.y, index: edgeIndex } as TopMostEdge)
        : result;
    },
    { minY: Number.MAX_SAFE_INTEGER, index: 0 } as TopMostEdge
  );

  return topEdge.index;
};
